import { lazy } from 'react';
import { Redirect } from 'react-router-dom';
// guards
import AuthGuard from '../guards/AuthGuard';
// layouts
import DashboardLayout from '../layouts/dashboard';
//
import { PATH_MANAGEMENT } from './paths';

// ----------------------------------------------------------------------

const ManageRoutes = {
  path: PATH_MANAGEMENT.root,
  guard: AuthGuard,
  layout: DashboardLayout,
  routes: [
    {
      exact: true,
      path: PATH_MANAGEMENT.general.management_cadence_detail,
      component: lazy(() => import('../views/management/cadence/ManageCadenceDetail'))
    },
    {
      exact: true,
      path: PATH_MANAGEMENT.general.management_lead_detail,
      component: lazy(() => import('../views/management/cadence/CadenceLeadDetail'))
    },
    {
      exact: true,
      path: PATH_MANAGEMENT.general.management_schedule_view,
      component: lazy(() => import('../views/management/endpoint/endPointScheduleView'))
    },
    {
      exact: true,
      path: PATH_MANAGEMENT.general.management_pending_lead_view,
      component: lazy(() => import('../views/management/endpoint/endPointPendingLeadView'))
    },
    {
      exact: true,
      path: PATH_MANAGEMENT.general.cadence,
      component: lazy(() => import('../views/management/cadence/Cadences'))
    },  
    {
      exact: true,
      path: PATH_MANAGEMENT.general.lead_search,
      component: lazy(() => import('../views/management/lead/Lead_Search'))
    },  
    {
      exact: true,
      path: PATH_MANAGEMENT.general.lead_details,
      component: lazy(() => import('../views/management/lead/LeadDetails'))
    },
    {
      exact: true,
      path: PATH_MANAGEMENT.general.endpoints,
      component: lazy(() => import('../views/management/endpoint/Endpoints'))
    },  
    // ----------------------------------------------------------------------

    {
      component: () => <Redirect to="/404" />
    }    
  ]
};

export default ManageRoutes;
